import { render, staticRenderFns } from "./pin-modal.vue?vue&type=template&id=36e52f9f&scoped=true"
import script from "./pin-modal.vue?vue&type=script&lang=js"
export * from "./pin-modal.vue?vue&type=script&lang=js"
import style0 from "./pin-modal.vue?vue&type=style&index=0&id=36e52f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e52f9f",
  null
  
)

export default component.exports